import React from "react";
import LineupSettingsComponent from "../components/lineupSettings/LineupSettingsComponent";

const LineupSettingsContainer = () => {
  return <LineupSettingsComponent />;
};

export default LineupSettingsContainer;
